import { format } from 'date-fns'
import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'
import * as mime from 'mime-types'
import { GeckoFileCategory, GeckoReportJSON } from 'types'
import { REPORT_ENTRY_UPLOAD_DATE_FORMAT } from 'utils/constants'

export function createGeckoReportData({
  file,
  fileCategory,
  units,
  components,
  jobs,
  inspections,
  vizInspFieldResponses,
  visualInspections,
  fileSource,
}: {
  file: File
  fileCategory: GeckoFileCategory
  units?: string[]
  components?: string[]
  jobs?: string[]
  inspections?: string[]
  vizInspFieldResponses?: string[]
  visualInspections?: string[]
  fileSource?: string
}): GeckoReportJSON {
  return omitBy(
    {
      visible_name: file.name,
      file_type: mime.extension(file.type),
      upload_date: format(Date.now(), REPORT_ENTRY_UPLOAD_DATE_FORMAT),
      size: file.size,
      units,
      components,
      jobs,
      inspections,
      file_category: fileCategory,
      file_source: fileSource,
      viz_insp_field_responses: vizInspFieldResponses,
      visual_inspections: visualInspections,
    },
    isNil
  ) as unknown as GeckoReportJSON
}
